






































import {Footer} from 'element-ui'
import {Component, Prop, Vue} from 'vue-property-decorator'
import toBgClClass from '@/filters/to-bg-cl-class'

@Component({
  components: {
    [Footer.name]: Footer,
  },
  methods: {
    toBgClClass
  },
})
export default class FooterLayout extends Vue {
  @Prop({default: 105}) height: number | 'auto'
  @Prop({default: 'white', type: String}) background: string
  @Prop({default: true, type: Boolean}) fixed: boolean

  get classes(): string[] {
    return [
      toBgClClass(this.background),
      this.fixed ? 'fixed' : '',
    ]
  }
}
